import React from 'react';
import { useMediaQuery } from 'react-responsive';

const MediaContext = React.createContext<{isPc: boolean}>({isPc: true});

export function useMediaContext() {
  return React.useContext(MediaContext);
}

export function MediaProvider({ children }: React.HTMLAttributes<Element>) {
  const [isPc, setIsPc] = React.useState(true);
  const value = {isPc: isPc}
  const mediaQuery = useMediaQuery({
      query: '(min-width: 912px)'
  })

  React.useEffect(() => {
    setIsPc(mediaQuery)
  }, [mediaQuery]);

  return (
    <MediaContext.Provider value={value}>{children}</MediaContext.Provider>
  );
}
